export const EMAIL_PATTERN =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function splitInviteEmails(value: string): string[] {
  return String(value || '')
    .split(',')
    .map((email) => email.trim())
    .filter(Boolean);
}

export function getInvalidInviteEmails(value: string): string[] {
  return splitInviteEmails(value).filter((email) => !EMAIL_PATTERN.test(email));
}

export function getInviteEmailValidation(value: string): {
  emails: string[];
  invalidEmails: string[];
  validEmails: string[];
  hasInvalidEmails: boolean;
} {
  const emails = splitInviteEmails(value);
  const invalidEmails = emails.filter((email) => !EMAIL_PATTERN.test(email));

  return {
    emails,
    invalidEmails,
    validEmails: emails.filter((email) => EMAIL_PATTERN.test(email)),
    hasInvalidEmails: invalidEmails.length > 0,
  };
}
